/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meow Mobile API
 * MeowStore 모바일 백엔드 API 명세
 * OpenAPI spec version: v1.0.0
 */

/**
 * 예측 결과
 */
export type WorldcupMyPredictionResponseResultStatus =
  (typeof WorldcupMyPredictionResponseResultStatus)[keyof typeof WorldcupMyPredictionResponseResultStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorldcupMyPredictionResponseResultStatus = {
  PENDING: 'PENDING',
  WIN: 'WIN',
  LOSE: 'LOSE',
  REFUND: 'REFUND',
} as const;
